<template>
	<div>
		<div class="content">
			<div class="card">
				<div class="card-body">
					<div v-if="!selectedCategory" class="default modern">
						<h1 style="font-size: 18px !important;">CATEGORIAS FINANCEIRAS</h1>
						<span class="subtitle f-14">Adicione e remova as categorias financeiras aqui</span>


						<div class="table-navbar row no-gutters">
							<div class="col-6">
								<button class="btn btn-primary" :class="{ 'opaque': type != 'e' }" @click="changeType('e')">Despesas</button>
								<button class="btn btn-primary " :class="{ 'opaque': type != 'r' }" @click="changeType('r')">Receitas</button>
							</div>
							<div class="col-6 text-right">
								<button class="btn btn-success" @click="create()"><span class="hidden-xs-down">ADICIONAR</span><span class="hidden-sm-up">+</span></button>
							</div>
						</div>

						<div class="clear"></div>

						<table class="table table-hover table-md f-13">
						  	<thead class="thead-default">
								<tr>
									<th style="width: 90%">NOME</th>
									<th style="width: 10%">TIPO</th>
								</tr>
							</thead>
							<tbody>
								<template v-for="(category, index) in categories">
									<template v-if="category.type == type">
										<tr :key="index" class="root pt-5" @click="edit(category)">
											<td class="root-title pointer" :class="{ 'red': category.type == 'e' }">{{ category.name }}</td>
											<td class="text-grey">{{ getTypeName(category.type) }}</td>
										</tr>

										<tr v-for="(sub_category, index2) in category.nodes">
											<td colspan="2" :key="index2" class="node" @click="edit(sub_category)">{{ sub_category.name }}</td>
										</tr>
										<tr>
											<td colspan="2" class="node new" @click="create(category)">+ Adicionar nova sub-categoria</td>
										</tr>
										<tr><td colspan="2" class="node blank"></td></tr>
									</template>
								</template>
							</tbody>	
						</table>

					</div>

					<category-form-component ref="categoryForm" @onCancelled="onCancelled($event)"></category-form-component>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import CategoryFormComponent  from './Category/CategoryFormComponent'
	import Category from '@/models/Category'
	import CategoryService from '@/services/CategoryService'

	export default {
		components: {
			CategoryFormComponent
		},
		data() {
			return {
				categories: [],
				selectedCategory: null,
				type: 'e'
			}
		},
		methods: {
			loadCategories() {
				CategoryService.load('?order=true').then(res => {
					this.categories = res.data
				})
				.catch(err => {

				})
			},
			reload() {
				this.loadCategories()
			},
			getTypeName(type) {
			    if(type == 'r') return 'Receita'
			    if(type == 'e') return 'Despesa'
			},
			create(parent) {

				let model;

				if(parent)  {
					model = new Category({ type: parent.type })
					model.parent_id = parent.id;
				}
				else {
					model = new Category({ type: this.type })
				}


				this.select(model)
			},

			select(category) {
				// this.form.load(category.type);
				this.$refs.categoryForm.open(category)
				this.selectedCategory = category
			},

			edit(category) {
				this.select(category)
			},
			onCancelled(bool) {
				this.selectedCategory = null;
				this.reload()
			},
			changeType(type){
				this.type = type;
			}
		},
		mounted() {
			this.reload()
		}
	}
</script>
<style>
	.root {
		padding-top: 15px !important;
	}

	.root-title {
		color: #0079bf;
		font-weight: bold;
	}

	.root-title.red {
		color: red;
	}

	.node {
		padding-left: 40px;
		cursor: pointer;
	}

	.node.new {
		color: #888;
	}

	.node.blank {
		border: 0;
		height: 35px;
	}

	.node.blank:hover {
		background-color: white;
	}
</style>